import { actionGenerator } from '../../../utils/redux/actionGenerator';
import { TGetDocumentGroupListFailed, EGetDocumentGroupListActionType } from './types';

export const getDocumentGroupListFailed: () => TGetDocumentGroupListFailed =
  actionGenerator<EGetDocumentGroupListActionType.Failed>(EGetDocumentGroupListActionType.Failed);
